module.exports = __webpack_public_path__ + "img/mm.e1e99376.svg";